import React from 'react';
import { i18n } from 'config/locales';

const DuplicateSession: React.FC = function () {
  return (
    <div className="login eapp-core" id="login">
      <div id="seal-header" className="seal-header text-center">
        <div className="content">
          <img src="/img/dcsa-logo.png" alt="National Background Investigation Services" />
          <h2>{i18n.t('login.title')}</h2>
        </div>
      </div>
      <div className="content">
        <div className="table one">
          <div id="error" className="auth error">
            <h3>{i18n.t('application.newTab.title')}</h3>
            {i18n.m('application.newTab.message')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateSession;
